import styled from "styled-components";
import Div from "../../common/ui/widgets/division";

export const HeaderUI = styled(Div)`
  background-color: ${(props) => props.theme.lightDark};
  .gray {
    color: #a7a7a7;
  }

  .main-navbar {
    border-radius: 0;
    height: auto;
    width: ${(props) => props.theme.width100Percentage};
    color: #ffffff;
    margin-bottom: ${(props) => props.theme.margin0};
  }

  .navbar-body {
    margin: 0 6%;
    display: flex;
    align-items: center;
  }

  .logo-wrapper {
    width: ${(props) => props.theme.width100Percentage};
    height: 56px;
    display: flex;
    align-items: center;
    gap: ${(props) => props.theme.gap4rem};
    justify-content: space-between;
  }

  .fluke-logo {
    padding-top: ${(props) => props.theme.padding12};
    width: ${(props) => props.theme.width150};
    height: ${(props) => props.theme.height55};
  }

  .header-tabs {
    font-size: ${(props) => props.theme.font12};
    display: flex;
    align-items: baseline;
    justify-content: space-between;
  }

  .lock-icon {
    width: ${(props) => props.theme.width10};
    padding-bottom: ${(props) => props.theme.padding4};
  }

  .header-tabs a {
    display: flex;
    align-items: center;
    padding: ${(props) => props.theme.padding20};
    width: max-content;
    text-transform: uppercase;
  }
  .header-tabs a:hover {
    line-height:${(props) => props.theme.lineHeight16} !important;
    background-color: #111111;
  }

  a {
    color: #a7a7a7;
    text-decoration: none;
  }

  .active {
    line-height:${(props) => props.theme.lineHeight16} !important;
    background-color: #ffc20e;
    color: #333333;
  }

  .non-active-class{
    line-height:${(props) => props.theme.lineHeight16} !important;
    background-color: #333333;
    color: #a7a7a7;
  }

  a.active:hover {
    background-color: #ffc20e;
    color: #333333;
  }

  .header-user-profile {
    display: flex;
    align-items: center;
    gap: ${(props) => props.theme.gap25px};
  }

  .header-user-profile img {
    height: ${(props) => props.theme.height32};
    width: auto;
    cursor: pointer;
  }

  .user-logo {
    position: relative;
    font-size: ${(props) => props.theme.font30};
    color: #999999;
    cursor: pointer;
    padding-top: ${(props) => props.theme.padding8};
  }

  .badge {
    padding: ${(props) => props.theme.padding2} ${(props) => props.theme.padding5};
    font-size: ${(props) => props.theme.font10};
    font-weight:inherit;
    background-color: #ffc20e;
    color: #111111;
    position: absolute;
    top: ${(props) => props.theme.top5};
    left: ${(props) => props.theme.left20};
    border-radius: ${(props) => props.theme.borderRadius10};
  }

  .user-name {
    position: relative;
    right: 5px;
    text-align: right;
    font-size: ${(props) => props.theme.font12};
    color: #a7a7a7;
    display: flex;
    flex-direction: column;
    width: ${(props) => props.theme.width100};
  }

  .user-name div {
    cursor: pointer;
    white-space: nowrap;
    width: auto;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .nav-profile-section {
    display: flex;
    width: ${(props) => props.theme.width100Percentage};
    justify-content: space-between;
    align-items: center;
    font-size: ${(props) => props.theme.font16};
    color: #a7a7a7;
  }

  .nav-profile-contact {
    margin-left: ${(props) => props.theme.margin45PercentageImportant};
    text-overflow: ellipsis;
  }

  .nav-profile-about {
    cursor: pointer;
    margin-left: ${(props) => props.theme.margin50};
  }

  .profile-logo {
    display: flex;
    font-size: ${(props) => props.theme.font30};
    height: ${(props) => props.theme.height36};
  }

  .phone-logo {
    display: none;
  }

  .profile-section {
    cursor: pointer;
    gap: ${(props) => props.theme.gap10px};

    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .vertical-divider {
    width: ${(props) => props.theme.width1};
    background-color: #808080;
    height: ${(props) => props.theme.height25};
  }

  .user-login {
    display: flex;
    color: #ffffff !important;
    gap: ${(props) => props.theme.gap10px};
    align-items: center;
  }

  .user-login a {
    color: #ffffff;
    font-size: ${(props) => props.theme.fontSize16};
    font-weight: normal;
  }

  @media (max-width: 1230px) {
    .burger-icon,
    .phone-logo {
      display: block !important;
    }

    .user-login,
    .vertical-divider,
    .nav-profile-contact {
      display: none;
    }

    .user-name,
    .nav-profile-about {
      display: none;
    }

    .header-tabs {
      display: none !important;
    }

    .header-tabs > a{
      text-transform: uppercase !important;;
    }

    .nav-profile-section {
      justify-content: flex-end;
      gap: ${(props) => props.theme.gap20Percentage};
    }
  }

  @media (min-width: 1230px) {
    .tab-modal-container {
      display: none !important;
    }
  }

  @media (max-width: 1230px) {
    .phone-logo {
      display: block;
    }
    .nav-profile-about {
      display: none;
    }
  }
  @media (max-width: 1260px) {
    .nav-profile-contact {
      display: none;
    }
  }
  @media (max-width: 360px) {
    .logo-wrapper {
        gap: 0;
        justify-content: space-evenly;
    }
    .navbar-body {
        margin: 0;
    }
  }
`;
